module.exports = __webpack_public_path__ + "img/valores-mais-com-menos.dc14de50.svg";